import React, { useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import Loader from "../utils/Loader";
import { userManualDownloadUrl, disclaimer } from "../utils/constants";
import useNotifications from "../hooks/useNotifications";
import NotificationPreviewModal from "./NotificationPreviewModal";
import NotificationDrawer from "./NotificationDrawer";

const ExhibitorHeader = () => {
  const navigate = useNavigate();
  const [isLoading, setLoader] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const { notifications, unreadCount, markAllRead, previewItem, openPreview, closePreview, showDrawer, openDrawer, closeDrawer } = useNotifications();
  const marqueeRef = useRef(null);
  const notificationRef = useRef(null);

  useEffect(() => { }, []);

  const onLogoutClick = () => {
    var code = sessionStorage.getItem('exhibitionCode')
    localStorage.clear();
    sessionStorage.clear();
    navigate(`/login/${code}`);
  };

  const loginData = JSON.parse(sessionStorage.getItem("loginDataSS") || "{}");
  const headerData = JSON.parse(
    sessionStorage.getItem("sessionHeaderData") || "[]"
  );

  const profileRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfile(false);
      }
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <>
      {isLoading && <Loader />}

      {isMobileMenuOpen && (
        <div
          className="mobile-menu-overlay exhibitor-mobile-overlay"
          onClick={closeMobileMenu}
        ></div>
      )}


      <div
        className={`mobile-sidebar-menu exhibitor-mobile-menu ${isMobileMenuOpen ? "mobile-menu-open" : ""
          }`}
      >
        <div className="mobile-menu-header exhibitor-menu-header">
          <button
            onClick={closeMobileMenu}
            className="exhibitor-menu-close-btn text-white"
          >
            ×
          </button>
          <div className="user-info exhibitor-user-info">
            <h5 className=" text-white mb-0">Welcome,</h5>
            <h4 className="text-uppercase fw-semibold text-white fw-bold">
              {loginData?.CompanyName || "Company Name"}
            </h4>
          </div>
        </div>
        <div className="mobile-menu-content exhibitor-menu-content">
          {/* MOBILE NOTIFICATIONS */}
          <div className="menu-section mobile-notification-section">
            <h6 className="exhibitor-section-title">
              <i className="fa fa-bell" aria-hidden="true"></i> Notifications
              {unreadCount > 0 && <span className="notification-badge" style={{ position: 'static', display: 'inline-flex', marginLeft: 4 }}>{unreadCount}</span>}
            </h6>
            {notifications.length === 0 ? (
              <p className="mobile-notif-item">No notifications</p>
            ) : notifications.slice(0, 3).map(n => (
              <div key={n.id} className="mobile-notif-item">
                <span className={`mobile-notif-dot${n.unread ? "" : " read"}`}></span>
                <span>{n.title}</span>
              </div>
            ))}
          </div>

          <div className="menu-section exhibitor-details-section">
            <h6 className="exhibitor-section-title">Exhibition Details</h6>
            <p className="exhibitor-detail-text mb-2">
              {sessionStorage.getItem("ExhibitionFromDateSS")} -{" "}
              {sessionStorage.getItem("ExhibitionToDateSS")} <br />
              {sessionStorage.getItem("ExhibitionAddressSS")}
            </p>
            <p className="exhibitor-detail-text mb-0">
              {headerData?.[0]?.StallTypeName || "Stall Type"} / {headerData?.[0]?.StallArea || "0"} sqm
            </p>
          </div>

          <div className="menu-section exhibitor-account-section">
            {/* <h6 className="exhibitor-section-title">Exhibitor Account</h6> */}
            <Link
              to={"/Change_Password"}
              className="exhibitor-menu-link mb-2"
              onClick={closeMobileMenu}
            >
              <i
                className="fa fa-cog exhibitor-menu-icon "
                aria-hidden="true"
              ></i>
              Change Password
            </Link>
            <button
              onClick={() => {
                closeMobileMenu();
                onLogoutClick();
              }}
              className="exhibitor-menu-link exhibitor-logout-btn"
            >
              <i
                className="fa fa-sign-out exhibitor-menu-icon"
                aria-hidden="true"
              ></i>
              Sign out
            </button>
          </div>
        </div>
      </div>

      <div className="app-header header sticky app-heder-with-logo pt-0">
        <div className="container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between">
            {/* LOGO */}
            <div className="side-header d-flex align-items-center">
              <img
                src={sessionStorage.getItem("ExhibitionLogoSS")}
                alt="logo"
                style={{ width: '90px', height: 'auto', margin: '0 auto' }}
              />
            </div>

            {/* EXHIBITION INFO */}
            <h5 className="exbheader text-white d-none d-md-block">
              {sessionStorage.getItem("ExhibitionFromDateSS")} -{" "}
              {sessionStorage.getItem("ExhibitionToDateSS")} <br />
              {sessionStorage.getItem("ExhibitionAddressSS")}
            </h5>

            {/* NOTIFICATION BELL + PROFILE ICON */}
            <div className="d-flex align-items-center gap-3">
              <div className="notification-bell-wrapper" ref={notificationRef} style={{ marginTop: '4px' }}>
                <i
                  className="fa fa-bell fa-lg text-white"
                  onClick={() => { setShowNotifications(!showNotifications); setShowProfile(false); }}
                  style={{ cursor: 'pointer' }}
                ></i>
                {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
                {showNotifications && (
                  <div className="notification-dropdown shadow">
                    <div className="notification-dropdown-header">
                      <span>Notifications</span>
                      {unreadCount > 0 && <button className="mark-all-read-btn" onClick={markAllRead}>Mark all as read</button>}
                    </div>
                    {notifications.length === 0 ? (
                      <div className="notification-empty"><i className="fa fa-bell-slash-o"></i><br />No notifications</div>
                    ) : notifications.slice(0, 3).map(n => (
                      <div key={n.id} className={`notification-item${n.unread ? " unread" : ""}`}>
                        <span className={`notification-item-icon ${n.type}`}>
                          {n.initial}
                        </span>
                        <div className="notification-item-content">
                          <div className="notification-item-title" dangerouslySetInnerHTML={{ __html: n.title }}></div>
                          {n.time && <div className="notification-item-time">{n.time}</div>}
                        </div>
                        <span className="notification-eye-btn" title="Preview" onClick={() => openPreview(n.id)}><i className="fa fa-eye"></i></span>
                      </div>
                    ))}
                    <div className="notification-dropdown-footer" style={{ cursor: 'pointer' }} onClick={openDrawer}>View all notifications</div>
                  </div>
                )}
              </div>

              {/* PROFILE ICON */}
              <div className="position-relative" ref={profileRef}>
                <i
                  className="fa fa-user-circle fa-2x text-white mt-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowProfile(!showProfile)}
                ></i>

                {/* PROFILE DROPDOWN */}
                {showProfile && (
                  <div className="profile-dropdown shadow">
                    <div className="profile-header">
                      <i className="fa fa-building-o"></i>{" "}
                      <strong>
                        {loginData?.CompanyName || "Company Name"}
                      </strong>
                    </div>

                    <div className="profile-body">
                      <p className="mb-0 pt-0">
                        {headerData?.[0]?.StallTypeName || "Stall Type"} / {" "}
                        {headerData?.[0]?.StallArea || "0"} sqm
                      </p>

                      {/* <p>
                      <i className="fa fa fa-list exh-header" aria-hidden="true" /> <span>
                        {sessionStorage.getItem('sessionHeaderData') != null &&
                          JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['StallTypeName']}
                      </span>
                    </p>
                    <p>

                      <i className="fa fa-th exh-header" aria-hidden="true" />{" "}
                      <span>
                        {sessionStorage.getItem('sessionHeaderData') != null &&
                          JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['StallArea']}(m<sup>2</sup>)
                      </span>
                    </p> */}

                    </div>

                    <div className="profile-footer">
                      <Link
                        to="/Change_Password"
                        className="dropdown-item bg-light px-2"
                        onClick={() => setShowProfile(false)}
                      >
                        <i className="fa fa-cog me-1"></i> Change Password
                      </Link>

                      <button
                        className="logout-btn dropdown-item px-2 bg-danger text-white"
                        onClick={onLogoutClick}
                      >
                        <i className="fa fa-sign-out me-1"></i> Logout
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>{/* end bell+profile group */}
          </div>

          {/* DISCLAIMER */}
          <marquee
            style={{ fontSize: "15px", color: "#fff" }}
            behavior="scroll"
            direction="left"
            scrollamount="5"
            ref={marqueeRef}
            onMouseOver={() => marqueeRef.current?.stop()}
            onMouseOut={() => marqueeRef.current?.start()}
          >
            <b>Disclaimer:</b> {disclaimer}
          </marquee>
        </div>

        <div className="mobile-toggle exhibitor-mobile-toggle d-lg-none">
          <button
            onClick={toggleMobileMenu}
            className="exhibitor-menu-toggle-btn"
          >
            <span className="exhibitor-menu-toggle-bar"></span>
            <span className="exhibitor-menu-toggle-bar"></span>
            <span className="exhibitor-menu-toggle-bar"></span>
          </button>
        </div>

      </div>
      <NotificationDrawer show={showDrawer} notifications={notifications} unreadCount={unreadCount} markAllRead={markAllRead} openPreview={openPreview} onClose={closeDrawer} />
      <NotificationPreviewModal notification={previewItem} onClose={closePreview} />
    </>
  );
};

export default ExhibitorHeader;
